module.exports = __webpack_public_path__ + "img/image2.099ef9a4.png";